import { Visibility } from "@mui/icons-material";
import React from "react";
import "./WidgetLarge.css";

function WidgetLarge() {
  return (
    <div className="widgetlarge">
      <span className="title">New Join Member</span>
      <div className="widgetsmall-members">
        <ul className="widgetsmall-list">
          <li className="widgetsmall-item">
            <img
              src="https://images.pexels.com/photos/3992656/pexels-photo-3992656.png?auto=compress&cs=tinysrgb&dpr=2&w=500"
              alt="user"
              className="widgetsmall-img"
            />
            <div className="widgetsmall-user">
              <span className="widgetsmall-username">Anna Keller</span>
              <span className="widgetsmall-title">Software Engineer</span>
            </div>
            <button className="widgetsmall-button">
              <Visibility />
              Display
            </button>
          </li>
          <li className="widgetsmall-item">
            <img
              src="https://images.pexels.com/photos/3992656/pexels-photo-3992656.png?auto=compress&cs=tinysrgb&dpr=2&w=500"
              alt="user"
              className="widgetsmall-img"
            />
            <div className="widgetsmall-user">
              <span className="widgetsmall-username">Anna Keller</span>
              <span className="widgetsmall-title">Software Engineer</span>
            </div>
            <button className="widgetsmall-button">
              <Visibility />
              Display
            </button>
          </li>
          <li className="widgetsmall-item">
            <img
              src="https://images.pexels.com/photos/3992656/pexels-photo-3992656.png?auto=compress&cs=tinysrgb&dpr=2&w=500"
              alt="user"
              className="widgetsmall-img"
            />
            <div className="widgetsmall-user">
              <span className="widgetsmall-username">Anna Keller</span>
              <span className="widgetsmall-title">Software Engineer</span>
            </div>
            <button className="widgetsmall-button">
              <Visibility />
              Display
            </button>
          </li>
          <li className="widgetsmall-item">
            <img
              src="https://images.pexels.com/photos/3992656/pexels-photo-3992656.png?auto=compress&cs=tinysrgb&dpr=2&w=500"
              alt="user"
              className="widgetsmall-img"
            />
            <div className="widgetsmall-user">
              <span className="widgetsmall-username">Anna Keller</span>
              <span className="widgetsmall-title">Software Engineer</span>
            </div>
            <button className="widgetsmall-button">
              <Visibility />
              Display
            </button>
          </li>
          <li className="widgetsmall-item">
            <img
              src="https://images.pexels.com/photos/3992656/pexels-photo-3992656.png?auto=compress&cs=tinysrgb&dpr=2&w=500"
              alt="user"
              className="widgetsmall-img"
            />
            <div className="widgetsmall-user">
              <span className="widgetsmall-username">Anna Keller</span>
              <span className="widgetsmall-title">Software Engineer</span>
            </div>
            <button className="widgetsmall-button">
              <Visibility />
              Display
            </button>
          </li>
          <li className="widgetsmall-item">
            <img
              src="https://images.pexels.com/photos/3992656/pexels-photo-3992656.png?auto=compress&cs=tinysrgb&dpr=2&w=500"
              alt="user"
              className="widgetsmall-img"
            />
            <div className="widgetsmall-user">
              <span className="widgetsmall-username">Anna Keller</span>
              <span className="widgetsmall-title">Software Engineer</span>
            </div>
            <button className="widgetsmall-button">
              <Visibility />
              Display
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default WidgetLarge;
